import React from 'react'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'

const AppraisalReportIndicator = ({ isUploadingDisabled, exteriorOnlyIndicator, handleChange, handleInvalid, invalidMessage }) =>
  <LgySubsection header='Appraisal Report Indicator' className='appraisal-report-indicator'>
    <fieldset id='appraisalReportIndicator'>
      <legend className='usa-sr-only'>Exterior Only Appraisal Report Indicator</legend>
      <label htmlFor='exteriorOnlyIndicator'>Exterior Only?
      <select className='usa-input-medium' name='exteriorOnlyIndicator' id='exteriorOnlyIndicator' required aria-required
          disabled={isUploadingDisabled} onInvalid={handleInvalid} value={exteriorOnlyIndicator} onChange={handleChange}>
          <option value=''>- Select -</option>
          <option value='Y'>Yes</option>
          <option value='N'>No</option>
        </select>
      </label>
    </fieldset>
    {invalidMessage.length > 0 && invalidMessage.find(error => error.startsWith('Exterior')) &&
      <span className='usa-input-error-message'>
        {invalidMessage.find(error => error.startsWith('Exterior'))}
      </span>}
  </LgySubsection>

export default AppraisalReportIndicator
